// hooks
import { useCallback, useEffect, useState, Fragment } from "react";
import useHttp from "hooks/use-http";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useParams } from "react-router-dom";

// icon material
import CheckIcon from "@mui/icons-material/Check";

// material
import { Grid, TextField, Button } from "@mui/material";

// styled styles
import {
  StyledStack,
  ButtonContainer,
  StyledTitle,
  StyledMenuItem,
} from "./editMsgFrame.style";

// components
import BackButton from "components/shared/BackButton";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import DrawerCM from "components/shared/Drawer";
import PaginationCM from "components/shared/Pagination";
import LoadingCM from "components/shared/Loading";
import NotifCard from "components/NotifCard";

// helpers
import Toast from "helper/toast";

// validation
import { FrameSchema } from "validations";

// constanst
import { PAGINATION_LIMIT } from "constants";

// request methods
// import {
//   addNotificationFrameRequest,
//   deleteNotificationFrameRequest,
//   getNotificationFrameRequest,
// } from "api/requests/";

export default function EditMessageFrame() {
  const { frame_id } = useParams();

  // frame data state
  const [frame, setFrame] = useState({ data: [], count: 0 });

  const { request, loading, setLoading } = useHttp(false);

  // pageinition state
  const [page, setPage] = useState(1);
  const {
    register,
    handleSubmit,
    resetField,
    control,
    formState: { errors },
  } = useForm({
    // resolver: yupResolver(FrameSchema),
    resolver: yupResolver(),
    defaultValues: {
      name: "",
      text: "",
    },
  });

  /////////// add new frame ///////////
  const onSubmit = async (values) => {
    // const res = await request({
    //   url: addNotificationFrameRequest,
    //   values: { title: values.name, text_message: values.text },
    // });
    // if (res) {
    //   Toast({ type: "success", title: "ثبت قالب" });
    // }
    // getFrame();
  };

  /////////// delete frame by id ///////////
  const handelDelete = async (id) => {
    // const res = await request({
    //   url: deleteNotificationFrameRequest,
    //   values: id,
    // });
    // getFrame();
    // if (res.data === 1) Toast({ type: "success", title: "حذف" });
  };

  /////////// get frame ///////////
  const getFrame = useCallback(async () => {
    // const { data: res } = await request({
    //   url: getNotificationFrameRequest,
    //   values: { skip: (page - 1) * PAGINATION_LIMIT, limit: PAGINATION_LIMIT },
    // });
    // let transformedData = res.data.map((items) => ({
    //   id: items.id,
    //   title: items.title,
    //   text: items.text_message,
    // }));
    // if (res) {
    //   resetField("name");
    //   resetField("text");
    // }
    // setFrame({ data: transformedData, count: res.count });
  }, [page, resetField, request]);

  useEffect(() => {
    getFrame();
    setLoading(false);
  }, [page, getFrame, setLoading, frame_id]);

  return (
    <DrawerCM title="ویرایش قالب پیام">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid item mt={3} xs={12}>
            <BackButton Route="/sms" />
          </Grid>
          <StyledStack>
            <StyledTitle>ویرایش قالب پیامک</StyledTitle>
            <Grid container>
              {/* if notif type change later, code down is useable */}
              {/* <Grid item md={6} xs={12} p={1}>
                <ReactHookFormSelect
                  id="notif-type"
                  label="نحوه ارسال"
                  control={control}
                  defaultValue={action === "sms" ? "sms" : "message"}
                  title="نحوه ارسال"
                >
                  <StyledMenuItem value="sms">پیامک (sms)</StyledMenuItem>
                  <StyledMenuItem value="message">پیام و اعلان</StyledMenuItem> 
                </ReactHookFormSelect>
              </Grid> */}
              <Grid item xs={12} p={1}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="name"
                  {...register("name")}
                  error={Boolean(errors.name)}
                  helperText={errors.name?.message}
                />
              </Grid>
              <Grid item xs={12} p={1}>
                <TextField
                  label="متن"
                  variant="outlined"
                  multiline
                  rows={6}
                  fullWidth
                  id="text"
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helperText={errors.text?.message}
                />
              </Grid>
              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Fragment>
      )}
    </DrawerCM>
  );
}
